"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.picker = exports.icon = exports.errorDiv = void 0;
var widgets_1 = require("@tableau/widgets");
var BorderWidth = 1;
var picker = {
    height: (BorderWidth + 3) * 2 + (4 * 2 + widgets_1.TabStyles.Sizing.RowHeight) * 2 + "px", // Taken from ChipPicker's calculation of maxHeight
};
exports.picker = picker;
var icon = {
    marginRight: widgets_1.TabStyles.Spacing.DefaultSpace,
    overflow: 'initial',
    fill: '#C93A47',
};
exports.icon = icon;
var errorDiv = {
    color: '#C93A47',
    verticalAlign: 'baseline',
    lineHeight: '21px',
};
exports.errorDiv = errorDiv;
//# sourceMappingURL=PickerStyle.js.map